import styled from "styled-components";
import { colors } from "theme/index";
import { ViewCommon } from "components/index";

export const View = styled(ViewCommon)`
  background-color: ${colors.White};
`;